import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// BUDGETING
// ═══════════════════════════════════════════════════════════════════════════
export const BUDGETING_ROUTES: RouteEntry[] = [
  {
    path: 'budgeting',
    component: 'BudgetingDashboard',
    label: '',
    allowedRoles: [], // no ProtectedRoute wrapper — function dashboard
    functionality: 'budgeting',
    hideFromNav: true,
    // This is the function landing page, not in FUNCTIONALITY_NAV
  },
  {
    path: 'budget-dashboard',
    component: 'BudgetDashboardPage',
    label: 'Dashboard',
    allowedRoles: [], // no ProtectedRoute wrapper
    functionality: 'budgeting',
    navSection: 'Overview',
    navIcon: 'Dashboard',
    // MISMATCH: route has no role guard but this should probably be restricted
  },
  {
    path: 'budget-assumptions',
    component: 'BudgetAssumptionsPage',
    label: 'Assumptions',
    allowedRoles: [], // no ProtectedRoute wrapper
    functionality: 'budgeting',
    navSection: 'Budgeting',
    navIcon: 'Calculate',
    // MISMATCH: route has no role guard
  },
  {
    path: 'budget-variance',
    component: 'BudgetVariancePage',
    label: 'Variance Analysis',
    allowedRoles: [], // no ProtectedRoute wrapper
    functionality: 'budgeting',
    navSection: 'Budgeting',
    navIcon: 'CompareArrows',
    // MISMATCH: route has no role guard
  },
];
